module.exports = __webpack_public_path__ + "static/img/2885_phase_function_Paper_Points.6fa6cab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2885_phase_function_Paper_Points.png
// module id = PACo
// module chunks = 0